/** The phone as the backend expects it: international format without the leading `+` (`+573…` → `573…`). */
export function toApiPhone(phone: string): string {
    return phone.replace(/^\+/, '');
}
